import { render } from "./CreationModificationInscription.vue?vue&type=template&id=4cc41fc4&scoped=true&ts=true"
import script from "./CreationModificationInscription.vue?vue&type=script&lang=ts"
export * from "./CreationModificationInscription.vue?vue&type=script&lang=ts"

import "./CreationModificationInscription.vue?vue&type=style&index=0&id=4cc41fc4&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc41fc4"]])

export default __exports__